export default "__VITE_ASSET__12b57cd3__$_?nuxt_component=async&nuxt_component_name=SvgoFreebitcoin__"